export const BASE_API = {
  // Auth
  login: "/user/login",

  // Dashboard
  getOverview: "/report/v1/dashboard/overview",
  getTopDealers: "/report/v1/dashboard/top-dealers",
  getTransactionsGraph: "/report/v1/dashboard/transactions",
  exportStatement: "/report/v1/supplier-payments/export",
  getPaymentHistory: "/report/v1/supplier-payments/history",

  // Traders
  getTopTraders: "/report/v2/dashboard/top-traders",
  getTraderList: "/report/v2/dashboard/traders-transaction-history",
  getTradersSummery: "/report/v2/dashboard/traders-summary",

  // Dealers
  getDealerList: "/report/v2/dashboard/distributors",

  // (File Upload)
  fileUpload: `/dealer/v1/file-image-upload`,
};
